<template>
  <v-row no-gutters>
    <v-col v-if="isFetched" cols="12">
      <sidebar-row>
        <v-col cols="12" class="px-0">
          <suggestions-input
            :data-source-name="activeDataSourceName"
            :feature-id="activeFeatureId"
            :layer-id="layerId"
            :geometry="geometry"
          />
        </v-col>
      </sidebar-row>
      <sidebar-row>
        <v-col cols="12" class="px-0">
          <suggestions-list
            :data-source-name="activeDataSourceName"
            :feature-id="activeFeatureId"
            :layer-id="layerId"
          />
        </v-col>
      </sidebar-row>
    </v-col>
    <main-loader v-else />
  </v-row>
</template>

<script>
import { call } from 'vuex-pathify';

import SidebarRow from '@/components/SidebarRow';
import SuggestionsInput from '@/components/SuggestionsInput';
import SuggestionsList from '@/components/SuggestionsList';
import MainLoader from '@/components/MainLoader';

export default {
  name: 'Suggestions',
  components: { SidebarRow, SuggestionsInput, SuggestionsList, MainLoader },
  props: {
    featureId: {
      type: [String, Number],
      required: true,
    },
    subFeatureId: {
      type: [String, Number],
    },
    dataSourceName: {
      type: String,
      required: true,
    },
    subDataSourceName: {
      type: String,
    },
    geometry: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    isFetched: false,
  }),
  computed: {
    activeDataSourceName() {
      return this.subDataSourceName || this.dataSourceName;
    },
    activeFeatureId() {
      return this.subFeatureId || this.subFeatureId === 0 ? this.subFeatureId : this.featureId;
    },
    layerId() {
      return this.$route.params.lid;
    },
  },
  methods: {
    getSuggestions: call('suggestions/getSuggestions'),
    async init() {
      this.isFetched = false;
      try {
        await this.getSuggestions({ data_source_name: this.activeDataSourceName, feature_id: this.activeFeatureId });
      } finally {
        this.isFetched = true;
      }
    },
  },
  mounted() {
    this.$watch(
      vm => {
        const { activeDataSourceName, activeFeatureId } = vm;
        return { activeDataSourceName, activeFeatureId };
      },
      nV => {
        const { activeDataSourceName, activeFeatureId } = nV;
        if (activeDataSourceName && (activeFeatureId || activeFeatureId === 0)) this.init();
      }
    );
    this.init();
  },
};
</script>
